<template>
  <div class="dialog-wrap">
    <el-dialog
      title="参考书编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="680px"
    >
      <el-form
        class="form"
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item label="上传主图：" prop="picture_url">
          <div class="cover-wrap">
            <div class="top">
              <div class="left">
                <el-image
                  class="cover-selected"
                  :src="dataForm.picture_url"
                  fit="cover"
                />
                <p class="label">当前主图</p>
              </div>
              <div class="middle"></div>
              <div class="right">
                <div class="covers">
                  <el-image
                    class="cover-item"
                    fit="cover"
                    v-for="(item, index) in covers"
                    :key="index"
                    :src="item"
                    @click="handleCoverChange(item)"
                  />
                </div>
                <p class="label">备选主图</p>
              </div>
            </div>
            <div>
              <el-upload
                class="avatar-uploader"
                :action="imgUploadUrl"
                :headers="uploadHeaders"
                :show-file-list="false"
                :on-success="handleUploadSuccess"
                :before-upload="handleBeforeUpload"
              >
                <el-button size="small" plain
                  ><i class="el-icon-upload2" />自定义主图</el-button
                >
                <div slot="tip" class="el-upload__tip">
                  支持扩展名：.jpg .png .jpge ; 图片大小为：105px*105px; 图片大小不超过1MB;
                </div>
              </el-upload>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="参考书名称" prop="name">
          <el-input
            v-model="dataForm.name"
            placeholder="请输入参考书名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="参考书描述" prop="description">
          <el-input
            v-model="dataForm.description"
            placeholder="请输入参考书描述"
            type="textarea"
            :rows="2"
          ></el-input>
        </el-form-item>
        <el-form-item label="参考书分类" prop="category_id">
          <el-select
            v-model="dataForm.category_id"
            placeholder="请选择参考书分类"
            style="width: 100%"
          >
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="在线状态" prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { consultUpdate, consultCategoryList } from "@/api/consult";
import { imgUploadUrl, uploadHeaders } from "@/config/index";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      covers: [
        "https://img.koudaikaoyan.com/48bd949706416aa48703331a9f2f0435.jpg",
        "https://img.koudaikaoyan.com/2feb63c79fb0bae005034b343c8aea39.jpg",
        "https://img.koudaikaoyan.com/0ceacfeb53b1ac8aca7b8c998847607d.jpg",
        "https://img.koudaikaoyan.com/00eb2d5d4559346aecf6d23d27dbf704.jpg",
      ],
      dataForm: this.content || {},
      categorys: [],
      rules: {
        name: [
          { required: true, message: "请输入参考书名称", trigger: "blur" },
          {
            min: 3,
            max: 30,
            message: "长度在 3 到 30 个字符",
            trigger: "blur",
          },
        ],
        description: [
          { required: true, message: "请输入参考书描述", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        category_id: [
          { required: true, message: "请选择参考书分类", trigger: "change" },
        ],
        status: [
          { required: false, message: "请设置上线状态", trigger: "change" },
        ],
        picture_url: [
          {
            required: true,
            message: "请上传主图",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!this.dataForm.picture_url) {
                return callback(new Error(rule.message));
              } else {
                callback();
              }
            },
          },
        ],
      },
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.fetchCategoryList();
      }
    },
    content(val) {
      this.dataForm = val;
    },
  },
  methods: {
    fetchCategoryList() {
      consultCategoryList({ isPaging: 0 }).then((res) => {
        this.categorys = res.list;
      });
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.cover = res.data.url;
      } else {
        this.$message.error(res.error);
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;

      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isLt2M;
    },
    handleCoverChange(url) {
      this.dataForm.picture_url = url;
    },
    handleSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            description: this.dataForm.description,
            category_id: this.dataForm.category_id,
            direction: this.dataForm.direction,
            status: this.dataForm.status ? 1 : 0,
          };
          consultUpdate(params)
            .then((res) => {
              this.$message.success(`更新成功`);
              this.$refs["dataForm"].resetFields();

              this.$emit("submit");
              this.handleClose();
            })
            .catch((error) => {
              console.log("error: ", error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
  .cover-wrap {
    .top {
      display: flex;
      margin-bottom: 10px;
    }
    .left,
    .right {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .middle {
      flex: 1;
    }
    .cover-selected {
      width: 92px;
      height: 125px;
    }
    .covers {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: space-between;
      width: 215px;
      height: 105px;
    }
    .cover-item {
      width: 50px;
      height: 68px;
      cursor: pointer;

      &:not(:nth-child(4n)) {
        margin-right: 5px;
      }
    }
    .el-upload__tip {
      line-height: 20px;
    }
  }
}
</style>
